<template>
    <div>
        <slot></slot>
        <template v-if="$slots.extra">
            <a class="read-more-link" href="#" v-show="!show" @click.prevent="handleClick">lire +</a>
            <b-collapse id="read-more" v-model="show">
                <slot name="extra"></slot>
            </b-collapse>
        </template>
    </div>
</template>

<script>
    import { BCollapse } from 'bootstrap-vue';

    export default {
        props: {
            id: String,
            disabled: Boolean,
        },
        components: {
            BCollapse
        },
        data() {
            return {
                show: this.disabled,
            }
        },
        methods: {
            handleClick() {
                if(!this.show) {
                    this.show = true;
                }
            }
        },
    }
</script>
